import React from 'react';
// import bobsled from "./icons/bobsled.png";
// import people from "./icons/people.png";
// import pool from "./icons/pool.png";
// import spiderWeb from "./icons/spider-web.png";
// import swing from "./icons/swing.png";

export default function Icon({ name }) {
  
  // console.log("icon name", name);
  function renderIcon() {
    try {
      return <img src={require(`./icons/${name}.png`)} style={{margin: "auto", height: '30px', width: '30px', objectFit: 'contain'}}/>
    }catch(err){
      return <div></div>
    }
  }
  return (
    <React.Fragment>{renderIcon()}</React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./resources/js/components/MysticIcon/index.js